module.exports = __webpack_public_path__ + "static/media/1001299.90c134cd.png";